// Navigation utility functions for use outside of React components
import { removeAuthToken } from './cookieUtils';
import { storeRedirectUrl } from './sessionTimeout';
let navigateFunction = null;

// Set the navigate function from React Router
export const setNavigate = (navigate) => {
    navigateFunction = navigate;
};

// Navigate to a route
export const navigateTo = (path, options = {}) => {
    if (navigateFunction) {
        navigateFunction(path, options);
    } else {
        // Fallback to window.location if navigate is not available
        window.location.href = path;
    }
};

// Navigate to login specifically - replace current history entry to prevent back navigation
export const navigateToLogin = (options = {}) => {
    if (window.location.pathname === '/login') return;
    storeRedirectUrl();
    removeAuthToken();
    navigateTo('/login', options);
};

// Navigate to access denied
export const navigateToAccessDenied = (options = {}) => {
    if (window.location.pathname === '/access-denied') return;
    navigateTo('/access-denied', options);
};
